
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/muses",
      function () {
        return require("private-next-pages/muses/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/muses"])
      });
    }
  